import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../../constants/constants";

export const otpserviceApi = createApi({
  reducerPath: "otpserviceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.ERO_USERMANAGEMENT_BASE_URL,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `Bearer ${localStorage.access_token}`);
      // headers.set("currentRole", localStorage.userrole);
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if(localStorage.userrole === "eci")
      {
        headers.set("state", "master");
      }
      return headers;
    }, }),
    keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    
    sendotp: builder.mutation({
      query: (data) => ({
        url: `api/v1/user-management/otp/send`,
        method: "POST",
       body: data,
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "atkn_bnd": localStorage?.atkn_bnd,
          "rtkn_bnd": localStorage?.rtkn_bnd,
          "channelidobo": "ETPBMS",    
          // "state":"MST"
        },
      }),
    }),

    verifyotp: builder.mutation({
      query: (data) => ({
        url: `api/v1/user-management/otp/verify`,
        method: "POST",
       body: data,
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "atkn_bnd": localStorage?.atkn_bnd,
          "rtkn_bnd": localStorage?.rtkn_bnd,
          "channelidobo": "ETPBMS",    
          // "state":"MST"
        },
      }),
    }),
  }),
});
export const {
  useSendotpMutation,
  useVerifyotpMutation
} = otpserviceApi;
